import React, { HTMLProps } from 'react'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles, Testable } from 'utils-next/types'

export type FormContainerProps = ExtendableStyles &
  HTMLProps<HTMLFormElement> &
  Testable & {
    disabled: boolean
  }

export function FormContainer({ className, disabled, ...otherProps }: FormContainerProps) {
  const { classes, cx } = useStyles()
  return <form className={cx(className, disabled && classes.formDisabled)} {...otherProps} />
}

const useStyles = makeStyles()({
  formDisabled: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
})
